import React, { useCallback, useMemo, useReducer } from 'react';

import deleteCompareModalConstants from './deleteCompareModal.constants';
import DeleteCompareModalContext from './deleteCompareModal.context';
import deleteCompareModalReducer from './deleteCompareModal.reducer';
import deleteCompareModalInitialState from './deleteCompareModalInitial.state';

/**
 * @type {React.FC}
 */

const DeleteCompareModalProvider = function({
  children,
  value = deleteCompareModalInitialState,
}) {
  const [state, dispatch] = useReducer(deleteCompareModalReducer, value);

  const hideModal = useCallback(() => {
    dispatch({ type: deleteCompareModalConstants.HIDE_MODAL });
  }, [dispatch]);

  const showModal = useCallback((isSingleDoor = false) => {
    dispatch({
      type: deleteCompareModalConstants.SHOW_MODAL,
      isSingleDoor,
    });
  }, [dispatch]);

  const context = useMemo(() => (
    {
      ...state,
      hideModal,
      showModal,
    }), [hideModal, showModal, state]);

  return (
    <DeleteCompareModalContext.Provider value={context}>
      {children}
    </DeleteCompareModalContext.Provider>
  );
};

export default DeleteCompareModalProvider;